import { useEffect, useState } from 'react';
import { useReadAloudPaging } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/ReadAloud';
import { ReadAloudPageType } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/ReadAloud/ReadAloudPageProvider/types';

const MINIMUM_PAGE_READING_TIME = 2000;

const useMinimumPageReadingTime = () => {
  const [{ activePages, totalPages }, { setDisableNextPage }] = useReadAloudPaging();
  const [pagesVisited, setPagesVisited] = useState<{ [page: number]: boolean }>({});

  useEffect(() => {
    if (activePages.every((page) => typeof page === 'number')) {
      const [leftPage, rightPage] = activePages;
      const currentPage =
        rightPage && rightPage !== ReadAloudPageType.COVER_PAGE ? rightPage : leftPage;
      const isLastPage = currentPage >= (totalPages as any);
      activePages.forEach((page) => {
        if (!pagesVisited[page]) {
          setPagesVisited((state) => ({ ...state, [page]: true }));
          setDisableNextPage(true);
          setTimeout(() => {
            if (!isLastPage) {
              setDisableNextPage(false);
            }
          }, MINIMUM_PAGE_READING_TIME);
        }
      });
    }
  }, [activePages]);
};

export default useMinimumPageReadingTime;
